import { TurnBuyersSortBy } from '../../enums/TurnBuyersSortBy';
import { TurnPortfoliosSortBy } from '../../enums/TurnPortfoliosSortBy';
import { VehicleType } from '../../enums/TurnVehicleType';
import { Action } from '../../types/Action';

export const setSortByTurn = (sortBy: TurnPortfoliosSortBy): Action => ({
  type: FilterTurnActionType.SET_SORT_BY_TURN,
  payload: sortBy,
});

export const filtersReset = (): Action => ({
  type: FilterTurnActionType.FILTERS_RESET as FilterTurnActionType.FILTERS_RESET,
});

export const setYears = (yearsFilter: number[]): Action => ({
  type: FilterTurnActionType.SET_YEARS as FilterTurnActionType.SET_YEARS,
  payload: yearsFilter,
});

export const setModels = (modelsFilter: string[]): Action => ({
  type: FilterTurnActionType.SET_MODELS as FilterTurnActionType.SET_MODELS,
  payload: modelsFilter,
});

export const setTrims = (trimsFilter: string[]): Action => ({
  type: FilterTurnActionType.SET_TRIMS as FilterTurnActionType.SET_TRIMS,
  payload: trimsFilter,
});

export const setVehicleTypes = (vehicleTypes: VehicleType[]): Action => ({
  type: FilterTurnActionType.SET_VEHICLE_TYPES as FilterTurnActionType.SET_VEHICLE_TYPES,
  payload: vehicleTypes,
});

export const setBrands = (brands: string[]): Action => ({
  type: FilterTurnActionType.SET_BRANDS as FilterTurnActionType.SET_BRANDS,
  payload: brands,
});

export const setDaysOnLot = (daysOnLotFilter: MinMaxFilter): Action => ({
  type: FilterTurnActionType.SET_DAYS_ON_LOT as FilterTurnActionType.SET_DAYS_ON_LOT,
  payload: daysOnLotFilter,
});

export const setMileage = (mileageFilter: MinMaxFilter): Action => ({
  type: FilterTurnActionType.SET_MILEAGE as FilterTurnActionType.SET_MILEAGE,
  payload: mileageFilter,
});

export const setPrice = (priceFilter: MinMaxFilter): Action => ({
  type: FilterTurnActionType.SET_PRICE as FilterTurnActionType.SET_PRICE,
  payload: priceFilter,
});

export const setSearch = (search: string): Action => ({
  type: FilterTurnActionType.SET_SEARCH as FilterTurnActionType.SET_SEARCH,
  payload: search,
});

export const setSortByBuyer = (sortBy: TurnBuyersSortBy): Action => ({
  type: FilterTurnActionType.SET_SORT_BY_BUYER,
  payload: sortBy,
});

export enum FilterTurnActionType {
  SET_SORT_BY_TURN = '[FILTER_TURN] Sort By Turn Set',
  FILTERS_RESET = '[FILTERS] Filters Reset',
  SET_YEARS = '[FILTERS] Years Set',
  SET_BRANDS = '[FILTERS] Brands Set',
  SET_MODELS = '[FILTERS] Models Set',
  SET_TRIMS = '[FILTERS] Trims Set',
  SET_VEHICLE_TYPES = '[FILTERS] Vehicle Types Set',
  SET_DAYS_ON_LOT = '[FILTERS] Days on Lot',
  SET_MILEAGE = '[FILTERS] Mileage',
  SET_PRICE = '[FILTERS] Price',
  SET_SEARCH = '[FILTERS] Search',
  SET_SORT_BY_BUYER = '[FILTER_TURN] Sort By Buyer Set',
}

export type FilterTurnAction = ReturnType<
  | typeof setSortByTurn
  | typeof filtersReset
  | typeof setYears
  | typeof setModels
  | typeof setTrims
  | typeof setVehicleTypes
  | typeof setBrands
  | typeof setDaysOnLot
  | typeof setMileage
  | typeof setPrice
  | typeof setSearch
  | typeof setSortByBuyer
>;

export type MinMaxFilter = {
  min: number;
  max: number;
};

export type SearchFilter = {
  current: string;
  previous: string;
};
